import React from 'react';
const ChatAppConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/apps/inbox',
			component: React.lazy(() => import('./ChatApp'))
		}
	]
};
export default ChatAppConfig;
